import styled from 'styled-components';
import {
  color,
  container,
  fontFamily,
  fontSize,
  fontWeight,
  screen,
  spacing
} from 'theme';

export const StyledWrapper = styled.div`
  padding: ${spacing('xl2')} ${spacing('md')} ${spacing('xl5')};
  position: relative;
  overflow: hidden;

  &.companiesForm {
    background: linear-gradient(
      90deg,
      #0a0227 0%,
      #0a0328 8.07%,
      #0a072c 15.54%,
      #0b0d32 22.5%,
      #0c153a 29.04%,
      #0d1f43 35.26%,
      #0e294d 41.25%,
      #0f3457 47.1%,
      #0f3e62 52.9%,
      #10496c 58.75%,
      #115376 64.74%,
      #125d7f 70.96%,
      #136587 77.5%,
      #146b8d 84.46%,
      #146f91 91.93%,
      #147092 100%
    );
    padding-top: ${spacing('xl5')};
  }
`;

export const StyledContainer = styled.div`
  max-width: ${container('xl')};
  margin: auto;
  color: ${color('white')};
  display: flex;
  flex-direction: column;
  gap: ${spacing('xl')};

  @media (min-width: ${screen('lg')}) {
    gap: ${spacing('xl3')};
  }
`;

export const StyledHeader = styled.div`
  line-height: 1.5;
  text-align: center;
  margin: auto;

  @media (min-width: ${screen('md')}) {
    font-size: ${fontSize('lg')};
    line-height: 1.4;
  }
`;

export const StyledDataList = styled.div`
  display: flex;
  margin: auto;
  justify-content: center;
  gap: ${spacing('xl')} ${spacing('xl2')};
  flex-wrap: wrap;
`;

export const StyledDataValue = styled.span`
  font-family: ${fontFamily('display')};
  font-size: ${fontSize('xl5')};
  line-height: 1;
  font-weight: ${fontWeight('semiBold')};
  color: ${color('indigo_300')};

  @media (min-width: ${screen('md')}) {
    font-size: ${fontSize('xl7')};
  }
  &::after {
    content: '';
    display: block;
    width: ${spacing('xl4')};
    height: ${spacing('xs')};
    background-color: currentColor;
    margin-top: ${spacing('xs')};
    margin-left: auto;
    margin-right: auto;
  }
`;

export const StyledDataItem = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${spacing('xs')};
  justify-content: flex-start;
  font-size: ${fontSize('sm')};
  line-height: 1.142;
  width: 40%;
  text-align: center;

  @media (min-width: ${screen('md')}) {
    font-size: ${fontSize('lg')};
    line-height: 1.2;
    width: 29%;
  }

  p {
    margin: 0;
  }

  &:nth-child(2) ${StyledDataValue} {
    color: ${color('cyan_300')};
  }
  &:nth-child(3) ${StyledDataValue} {
    color: ${color('purple_300')};
  }
  &:nth-child(4) ${StyledDataValue} {
    color: ${color('emerald_300')};
  }
  &:nth-child(5) ${StyledDataValue} {
    color: ${color('sun_300')};
  }
  &:nth-child(6) ${StyledDataValue} {
    color: ${color('navy_300')};
  }
`;
